export type IHomepageResources = typeof HomepageResources;

const HomepageResources = {
    cashbackSectionTitle: "Cashback",
    cashbackSectionSubTitle:
        "Rób bezpieczne zakupy z goodie cashback,<br>a <b> część pieniędzy wróci do Ciebie</b>",
    cashbackSectionButton: "Dowiedz się więcej",
    cashbackSectionBrandsTitle: "Sklepy z cashback",
    cashbackSectionMoreButton: "Więcej sklepów",

    discountsSectionSubtitle:
        "<b>Znajdź okazje i kody rabatowe</b> ulubionych sklepów! Na jednej platformie zebraliśmy dla Ciebie wszystkie oferty, promocje, wydażenia i kody rabatowe w centrach handlowych, sklepach internetowych i restauracjach w Twojej okolicy. Kliknij na konkretne okazje, albo przejdź do podstrony ulubionej marki.",
    discountsSectionTitle: "<b>Okazje</b> i kupony rabatowe",
    discountsSectionButton: "Przeglądaj okazje",

    flyersSectionTitle: "<b>Najnowsze</b> gazetki promocyjne",
    flyersSectionSubtitle:
        "<b>Przeglądaj najnowsze gazetki</b> ze sklepów blisko Ciebie! Bądź zawsze na bieżąco i nie przegap wyprzedaży i gorących promocji! Gazetki wszystkich Twoich ulubionych sklepów w jednym miejscu.",
    flyersSectionButton: "Przeglądaj gazetki",
    flyersSectionBrandsMoreButton: "Więcej Gazetek",
    flyersSectionBrandList: "Popularne gazetki",

    appSectionOffersTitle: "<b>Z aplikacją goodie</b><br/> możesz więcej",

    blogSectionTitle: "<b>Inspiracje Zakupowe</b>",

    goodieInfo: "<b>goodie:</b> zawsze najnowsze gazetki, kody rabatowe, cashback, promocje.",

    shoppingMallsSection: {
        title: "<b>Promocje w galeriach handlowych</b>",
        buttonText: "Dowiedz się więcej",
    },

    accessibility: {
        cashbackAll: "Zobacz wszystkie sklepy oferujące zwrot gotówki",
        yourCashback: "Sprawdź wszystko o zwrocie gotówki",
        discountsAll: "Zobacz wszystkie dostępne rabaty",
        shoppingMallAll: "Zobacz wszystkie centra handlowe",
        flyersAll: "Zobacz wszystkie gazetki",
    },
};

export default HomepageResources;
